import styled from 'styled-components';

export const TrainingCollapsiblePanelContainer = styled.div`
  width: 100%;
`;
